import env from "../../src/config/env";

export default env;
